import { jsxs as t, jsx as r, Fragment as N } from "react/jsx-runtime";
import { Divider as w } from "./index.es18.js";
import m from "classnames";
import e from "./index.es5476.js";
import { useIsEllipsis as l } from "@placer-ui/hooks";
import { useScreenZoom as u } from "./index.es530.js";
import { SimpleTooltip as a } from "./index.es120.js";
import { Heading as E } from "./index.es489.js";
import { MenuText as y } from "./index.es490.js";
const z = ({ headline: s, description: i, Thumbnail: n, hasDivider: c }) => {
  const { isOverflowing: p, textElmRef: f } = l(), { isOverflowing: d, textElmRef: v } = l(), { zoomPercentage: g } = u(), o = g >= 200, h = m(e.wrapper, {
    [e.noDescription]: !i
  }), x = m(e.content, {
    [e.notWrapping]: !o
  });
  return /* @__PURE__ */ t("header", { className: e.header, children: [
    /* @__PURE__ */ t("div", { className: h, children: [
      !!n && /* @__PURE__ */ r(N, { children: n }),
      /* @__PURE__ */ t("div", { className: x, children: [
        /* @__PURE__ */ r(a, { title: s, isActive: p && !o, children: /* @__PURE__ */ r(
          E,
          {
            variant: "h5",
            color: "primary",
            isEllipsis: !o,
            ref: f,
            children: s
          }
        ) }),
        i && /* @__PURE__ */ r(
          a,
          {
            title: i,
            isActive: d && !o,
            children: /* @__PURE__ */ r(
              y,
              {
                color: "gray",
                variant: "regular",
                element: "p",
                ref: v,
                children: i
              }
            )
          }
        )
      ] })
    ] }),
    c && /* @__PURE__ */ r(w, {})
  ] });
};
export {
  z as CardHeader
};
//# sourceMappingURL=index.es682.js.map
